/**
 * @file Chooses the Invoicing tab's invoiced, outstanding and overdue amount
 * columns and their title from the granted level of an answer. Consumers:
 * `analyticsInvoiceTotals`, `analyticsReceivableAging` and
 * `analyticsInvoices`. My sales and My team read the credited share as
 * "Credited amount"; Org reads the whole invoice amount, the `line*` columns,
 * as "Invoice amount". The level is the answer's granted one, never the
 * requested scope.
 */
import type { AnalyticsScopeLevel } from '#types';

import type { AnalyticsInvoiceAmount } from './analyticsInvoicingTab.types';

export const analyticsInvoiceAmount = (
  level: AnalyticsScopeLevel,
): AnalyticsInvoiceAmount =>
  level === 'org'
    ? {
        invoiced: 'lineInvoicedAmount',
        outstanding: 'lineOutstandingAmount',
        overdue: 'lineOverdueAmount',
        title: 'Invoice amount',
      }
    : {
        invoiced: 'invoicedAmount',
        outstanding: 'outstandingAmount',
        overdue: 'overdueAmount',
        title: 'Credited amount',
      };
